module.exports = __webpack_public_path__ + "static/media/13-g6.94049756.jpg";